document.querySelectorAll('.imgtextbtn_modal').forEach(function(element) {
  element.addEventListener('click', function() {
    let modalId = element.dataset.target; // Accessing data-target attribute
    document.getElementById(modalId).classList.add('show_modal'); // Show the modal
    document.body.classList.add('ingredients_modal_open'); // Modify body class
  });
});


document.querySelectorAll('.close_modal').forEach(element => {
  element.addEventListener('click', function() {
    document.querySelectorAll('.ingredients-modal').forEach(modal => {
      modal.classList.remove('show_modal');
    });
    document.body.classList.remove('ingredients_modal_open');
  });
});


document.querySelectorAll('.modal-ans').forEach(element => {
  element.addEventListener('click', function() {
    if (window.innerWidth < 989) {
      const modalTitle = this.querySelector('h4').innerHTML;
      const modalExtraContent = this.querySelector('.extra-content').innerHTML;
      const modalAnsSubtitle = this.querySelector('.modal-ans_subtitle').innerHTML;
      const modalAnsContent = this.querySelector('.modal-ans_content').innerHTML;
      const popup = document.querySelector('.ingredient-popup');

      popup.querySelector('.modal-ans_title h4').innerHTML = modalTitle;
      popup.querySelector('.extra-content').innerHTML = modalExtraContent;
      popup.querySelector('.modal-ans_subtitle').innerHTML = modalAnsSubtitle;
      popup.querySelector('.modal-ans_content').innerHTML = modalAnsContent;

      document.querySelectorAll('.ingredient-popup, .ingredient-popup_overlay').forEach(el => {
        el.classList.remove('no-disp');
      });
    }
  });
});

document.querySelectorAll('.close_ingredient').forEach(element => {
  element.addEventListener('click', function() {
    document.querySelectorAll('.ingredient-popup, .ingredient-popup_overlay').forEach(el => {
      el.classList.add('no-disp');
    });
  });
});
